import { ReactComponent as BkgComponent } from '../assets/bkg-info.svg';
import SvgRouteNavigator from '../components/SvgRouteNavigator';

const linkRoutes: Record<string, string> = {
  "link-3": "/info/year/3",
  "link-4": "/info/year/4",
  "link-5": "/info/year/5",
  "link-6": "/info/year/6",
  "link-7": "/info/year/7",
  "link-8": "/info/year/8",
  "link-9": "/info/year/9",
  "link-mix": "/info/misc",
  "link-back": "/main",
};

function Info() {
  return <SvgRouteNavigator SvgComponent={BkgComponent} linkRoutes={linkRoutes} containerClassName="page-info-bkg" />;
}

export default Info;